import { useEffect, useState } from "react";
import { OPERTIONS_URL } from "../../../common/common";
import { ApiService } from "../../../service/api.service";
import { useNavigate } from "react-router-dom";


  interface ClientDetailsComponentProps {
    id: any;
  }

  const ClientDetailsComponent: React.FC<ClientDetailsComponentProps> = ({ id }) => {
    const apiService = new ApiService()
    const navigate = useNavigate();
    const [data,setData]= useState<any>([])
    const [clientData,setClientData]=useState<any>({})
    const getClientData = async () => {
      try {
        const response:any = await apiService.getApi(`${OPERTIONS_URL}/booking/details-route?bookingId=${id}`);
    
        if (response.status === "200" && response.body) {
          const { bookingDetail, clientDetail } = response.body[0];
          setClientData(response.body[0].clientDetail)
          const clientDetails = [
            { label: "No Vehicle", value: bookingDetail?.bookingNumber || "N/A" },
            { label: "No Container", value: bookingDetail?.daysLeft?.toString() || "N/A" },
            { label: "Nature", value: "Export" }, // Static value, adjust if dynamic
            { label: "Type", value: "Direct Drop" }, // Static value, adjust if dynamic
            { label: "Client", value: clientDetail?.firstName || "N/A" },
            { label: "Phone", value: `${clientDetail?.countryCode} ${clientDetail?.contactNumber}` || "N/A" },
            { label: "Email", value: clientDetail?.emailId || "N/A" },
            { label: "Company", value: "Kittivaasal Technologies Pvt Ltd" }, // Static value
            { label: "Location", value: "Chennai" }, // Static value
          ];
    
          console.log("Formatted Client Details:", clientDetails);
          setData(clientDetails);
        } else {
          console.error("Failed to fetch client data or invalid response");
        }
      } catch (error) {
        console.error("Error fetching client data:", error);
      }
    };
    
    useEffect(()=>{
      if(id){
        getClientData()
      }
    },[id])
    return (
      <div className="flex flex-wrap justify-around">
        {data.slice(0, 4).map((detail:any, index:number) => (
          <div key={index} className="text-left">
            <p className="text-gray-500 font-medium text-[14px]">
              {detail.label}
            </p>
            <p className="font-[400] text-[14px]">{detail.value}</p>
          </div>
        ))}
        <div className="text-left">
          <p className="text-gray-500 font-medium text-[14px] text-left">Client</p>
          <button
            className="font-medium text-[14px] text-[#444FBD] text-left"
            onClick={() => navigate(`/client/view/${clientData.clientId}`)}
          >
            {clientData.firstName||""}
          </button>
          <p className="font-[400] text-[14px] text-left">{clientData.countryCode || "+91" +" "+clientData.contactNumber ||""}</p>
        </div>
        <div className="text-left">
          <p className="text-gray-500 font-medium text-[14px] text-left">Company</p>
          <button
            className="font-medium text-[14px] text-[#444FBD] text-left"
            onClick={() => navigate(`/client/view/${clientData.clientId}`)}
          >
           {clientData.firstName||""}
          </button>
          <p className="text-left font-[400] text-[14px]">Chennai</p>
        </div>
      </div>
    );
  };
  
  export default ClientDetailsComponent;
  